import { AuthorizedCheckCallback } from './guards/authorize.guard';
import { Rights } from './services/auth.service';

interface AuthorizeCheckFunctions {
  services: AuthorizedCheckCallback;
  users: AuthorizedCheckCallback;
  violations: AuthorizedCheckCallback;
  employees: AuthorizedCheckCallback;
  departments: AuthorizedCheckCallback;
  [name: string]: AuthorizedCheckCallback;
}

const authorizeCheckFunctions: AuthorizeCheckFunctions = {
  services: (rights: Rights): boolean => {
    return rights.services.see;
  },

  violations: (rights: Rights): boolean => {
    return rights.violation.see;
  },

  users: (rights: Rights): boolean => {
    return rights.user.see;
  },

  statistics: (rights: Rights): boolean => {
    return rights.statistics.industrialSafety;
  },

  employees: (rights: Rights): boolean => {
    return rights.employee.see;
  },

  departments: (rights: Rights): boolean => {
    return rights.department.see;
  },

  rules: (rights: Rights): boolean => {
    return rights.rule.see;
  },

  zones: (rights: Rights): boolean => {
    return rights.zone.see;
  },

  cameras: (rights: Rights): boolean => {
    return rights.camera.see;
  }
};

export { authorizeCheckFunctions };
